// ALL IMPORTS MUST BE AT TOP

import React, { useState, useEffect } from "react";

import { Link } from "react-router-dom";
import "./home.css";
import Header from "../components/Header";
import Services from "./services";
import DoctorCard from "../components/doctorCard";


import GrandOpeningPopup from "../components/GrandOpeningPopup";

/// Swiper v12 components + modules
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Autoplay,
  EffectCreative,
  Pagination,
  Navigation,
} from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/effect-creative";
import "swiper/css/pagination";
import "swiper/css/navigation";

import AppointmentModal from "../components/AppointmentModal";

function Home() {
  const [openModal, setOpenModal] = React.useState(false);
  const [doctors, setDoctors] = useState([]);

  useEffect(() => {
    fetch("https://oculus-api.onrender.com/api/doctors")
      .then(res => res.json())
      .then(data => {
        setDoctors(data);
      })
      .catch(err => console.error(err));
  }, []);
  return (
    <div className="homepage">
      <Header/>
      {/* HERO SECTION */}
      <section className="hero">
        <div className="hero-text">
          <p className="hero-tagline">Advanced Eye Care, in Nagaon</p>
          <h1>
            A BETTER VISION <span className="highlight">IS</span>,<br /> OUR
            RESPONSIBILITY
          </h1>
          <p className="hero-subtitle">
            Comprehensive eye checkups, retina care, cataract surgery and more —
            under one roof with experienced specialists.
          </p>

          <div className="hero-buttons">
            <button
              className="btn primary-btn"
              onClick={() => setOpenModal(true)}
            >
              Book Appointment
            </button>
            <a href="tel:+916000678383" className="btn secondary-btn">
              Call Now
            </a>
          </div>

          <div className="hero-stats">
            
            <div>
              {/* <h3>15+ yrs</h3> */}
              {/* <p>Clinical experience</p> */}
            </div>
            <div>
              <h3>24/7</h3>
              <p>Emergency support</p>
            </div>
          </div>
        </div>

        {/* FLOATING SLIDER INSIDE HERO */}
        <div className="infinite-slider">
          <div className="infinite-track">
            <div className="card">Retina & Cataract</div>
            <div className="card">Advanced Technology</div>
            <div className="card">Personalised Care</div>

            <div className="card">Retina & Cataract</div>
            <div className="card">Advanced Technology</div>
            <div className="card">Personalised Care</div>
          </div>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section className="about">
        <div className="about-text">
          <h2>About Our Eye Hospital</h2>
          <p>
            We are a super-speciality eye care centre offering complete care for
            retina, cataract, glaucoma, cornea and general eye problems.
          </p>
          <p>
            Our specialists combine clinical expertise with compassionate care
            so that every patient understands their condition and treatment
            options.
          </p>
          <ul>
            <li>Full eye checkup & screening</li>
            <li>Retina & cataract speciality clinics</li>
            <li>Support for diabetic eye disease and glaucoma</li>
          </ul>
          <Link to="/services" className="btn primary-btn about-btn">
            View All Services
          </Link>
        </div>
        <div className="about-card">
          <h3>Why patients trust us</h3>
          <p>
            From routine checkups to complex retinal surgeries, we use
            evidence-based protocols and advanced machines to keep your eyes
            healthy.
          </p>
          <p className="about-note">
            “Your eyes are priceless. We treat them that way.”
          </p>
        </div>
      </section>
      {/* SERVICES SECTION */}
      <section className="services-section">
        <h2>Our Key Services</h2>
        <p className="section-subtitle">
          Complete eye care for you and your family.
        </p>

        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          autoplay={{ delay: 3000 }}
          pagination={{ clickable: true }}
          loop={true}
          spaceBetween={30}
          slidesPerView={1}
          className="services-slider"
          onInit={(swiper) => {
            swiper.params.navigation.prevEl = ".service-prev";
            swiper.params.navigation.nextEl = ".service-next";
            swiper.navigation.init();
            swiper.navigation.update();
          }}
        >
          <SwiperSlide>
            <div className="service-card-long">
              <button className="service-prev custom-arrow">‹</button>
              <button className="service-next custom-arrow">›</button>
              <h3>Cataract Surgery</h3>
              <p>
                Phacoemulsification & premium lens implants for clear vision and
                quick recovery.
              </p>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="service-card-long">
              <button className="service-prev custom-arrow">‹</button>
              <button className="service-next custom-arrow">›</button>
              <h3>Retina Clinic</h3>
              <p>
                Management of diabetic retinopathy, retinal detachment and
                macular diseases.
              </p>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="service-card-long">
              <button className="service-prev custom-arrow">‹</button>
              <button className="service-next custom-arrow">›</button>
              <h3>Glaucoma Care</h3>
              <p>
                Early diagnosis and long-term management to protect your optic
                nerve.
              </p>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="service-card-long">
              <button className="service-prev custom-arrow">‹</button>
              <button className="service-next custom-arrow">›</button>
              <h3>Comprehensive Checkup</h3>
              <p>
                Routine eye exams, glasses prescription & screening for
                diseases.
              </p>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="service-card-long">
              <button className="service-prev custom-arrow">‹</button>
              <button className="service-next custom-arrow">›</button>
              <h3>Paediatric Eye Care</h3>
              <p>Special focus on children’s vision, squint & lazy eye.</p>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="service-card-long">
              <button className="service-prev custom-arrow">‹</button>
              <button className="service-next custom-arrow">›</button>
              <h3>LASIK & Refractive</h3>
              <p>Options to reduce dependence on glasses & contact lenses.</p>
            </div>
          </SwiperSlide>
        </Swiper>
      </section>
      {/* DOCTORS PREVIEW */}
      <section className="doctors-preview" id="doctors-list">
        <div className="doctors-heading">
          <h2>Meet Our Specialists</h2>
          <p>
            Experienced ophthalmologists trained in retina, cataract, cornea and
            glaucoma care.
          </p>
        </div>
{/* Need to add doctor cards from database here */}
        <div className="doctor-cards">
          {doctors.map((doctor) => (
            <DoctorCard key={doctor._id} doctor={doctor} />
          ))}
        </div>
{/* ends here */}
      </section>
      {/* CTA / CONTACT SECTION */}
      {/* <section className="call-to-action">
        <div className="cta-text">
          <h2>Worried about your vision?</h2>
          <p>
            Book a consultation today and let our team guide you with a simple,
            clear treatment plan.
          </p>
        </div>
        <div className="cta-actions">
          <Link to="/services" className="btn primary-btn">
            Book Appointment
          </Link>
          <a href="tel:+910000000000" className="btn ghost-btn">
            Call Reception
          </a>
        </div>
      </section> */}

      <AppointmentModal
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
      />
    </div>
  );
}

export default Home;
